const black = "#000000";
const white = "#ffffff";
const transparent = `${black}00`;

const tintColorLight = "#2f95dc";
const tintColorDark = white;

const primary = "#8a2be2";
const accent = "#48d1cc";

const transparencyLight = "33";
const transparencyDark = "99";

const commonColors = {
  primary,
  primaryLight: `${primary}${transparencyLight}`,

  accent,
  accentLight: `${accent}${transparencyLight}`,

  black,
  white,
  transparent,

  textInfo: "#aaaaaa",
  textWarn: "#F1C40F",
  textError: "##CB4335",
  textDisabled: `${black}${transparencyDark}`,

  backgroundInfo: "#dddddd",
  backgroundWarn: "#F9E79F",
  backgroundError: "#F5B7B1",
  backgroundDisabled: `${black}${transparencyLight}`,
  backgroundDivider: "#cccccc",

  tabIconDefault: "#cccccc",

  backdrop: `${black}${transparencyDark}`,
};

export default {
  light: {
    ...commonColors,

    text: black,
    background: white,

    tint: tintColorLight,
    tabIconSelected: tintColorLight,
  },
  dark: {
    ...commonColors,

    text: white,
    background: black,

    tint: tintColorDark,
    tabIconSelected: tintColorDark,
  },
};
